/**
 * Wire contract for Operations > Overview, kept in its own pure module with NO imports.
 *
 * Same reason reportContract.ts exists: the hooks import lib/firebase at module load, so anything
 * a test wants to assert on must live where importing it does not start a Firebase client. Kept
 * beside reportContract.ts rather than inside it so this phase does not edit a shared file.
 *
 * These strings are Zod literals on the server. A mismatch is not a type error on either side: it
 * is a runtime "invalid-argument" from a callable that looks correct in both files.
 */

/** On the report dispatcher (pipelineTrackerReportAction). */
export const OPERATIONS_OVERVIEW_REPORT_ACTION = 'operationsOverviewReport';

/**
 * On the settings dispatcher (pipelineTrackerTaxonomyAction): the tenant-entered monthly figures
 * (Google reviews, rating, SFG audit %). Implemented by the targets and monthly inputs work; this
 * view only reads it.
 */
export const GET_MONTHLY_INPUTS_ACTION = 'getMonthlyInputs';

/** Named owners of the inputs the blocked sections wait on (founder decision, 28 Sep 2026). */
export const OWNER_CHRISTIAN = 'Christian Paterson (Auctus)';
export const OWNER_SALESTREKKER = 'Salestrekker';
export const OWNER_EVOKE = 'Evoke';
